<script>
  import Carto from "./Carto.svelte"
  import Resizer from "$lib/components/guardian/Resizer.svelte"

  let { name, geoJsonURL = "", geoJsonStyles = [], riverDataURL = "https://interactive.guim.co.uk/25/06/10-oz-river-level-flooding/map-03-10.json" } = $props()

  let dataTimestamp = $state(null)

  const subtitle = $derived(
    `Showing selected river monitoring stations that have reached flood thresholds across Australia. Data is on a delay and should not be used in case of an emergency - please consult official sources.${dataTimestamp ? ` Latest as of ${dataTimestamp}.` : ""}`
  )
</script>

<Resizer atomName="#{name}" />

<Carto
  geoJsonURL={geoJsonURL}
  riverDataURL={riverDataURL}
  geoJsonStyles={geoJsonStyles}
  onTimestamp={(t) => (dataTimestamp = t)}
  MAP_INTERACTIVE={true}
  center={[151.5, -26]}
  zoom={6}
  headline="River flooding across Australia"
  subtitle={subtitle}
  source="Guardian graphic. Source: Australian Bureau of Meteorology"
/>

<style lang="scss">
</style>
